// extracted by mini-css-extract-plugin
export default {"logo":"Print_logo__2LQpZ","hidden":"Print_hidden__irfWP","table":"Print_table__pS1MK","notes":"Print_notes__cffGy","grid":"Print_grid__SMDnh"};